module.exports = __webpack_public_path__ + "img/bb8.c3fb3eb2.jpg";